export const GET_OFFERS = `
query($bountyId: ID, $start: Int, $limit: Int) {
    offers(
      where: { bountyId: $bountyId }
      start: $start
      limit: $limit
      sort: "created_at:desc"
    ) {
      id
      introTime
      status
      relation
      introPerson {
        id
        firstName
        lastName
        rating
      }
      comment
    }
  }   
  `;

export const GET_MY_INTROS = `
query($profileId: ID, $status: String, $start: Int, $limit: Int) {
  getMyIntros(profileId: $profileId, status: $status, limit: $limit, start: $start) {
    introTime
    status
    introPerson {
      id
      firstName
      lastName
    }
    bountyId {
      id
      reason
      demandPrice
      title
      fullName
      company
      status
    }
  }
}
`;

export const MY_INTROS_COUNT = `
query($introPerson: ID) {
  offersConnection(
    where: { introPerson: $introPerson, status: "accepted", isAccepted: true }
  ) {
    aggregate {
      count
    }
  }
}
`;

export const GET_COMPLETE_OFFER = `
query($bountyId: ID) {
  completeOffers(bountyId: $bountyId) {
    introTime
    bountyId {
      bountyType
    }
    introPerson {
      id
      firstName
      lastName
      rating
    }
    relation
    comment
  }
}
`;


export const OFFER_COUNT = `
query($bountyId: ID) {
  offersConnection(where: { bountyId: $bountyId, status: "hold" }) {
    aggregate {
      count
    }
  }
}
`;


export const INTROS_COUNT = `
query($profileId: ID, $status: String) {
  myIntrosCount(profileId: $profileId, status: $status) {
    count
  }
}
`;